
import {Component, Vue} from 'vue-property-decorator';
import {getReconciliationAllocateDetail} from "@/api/invoice/index";
import {parseTime} from "@/utils";

@Component({
  name: 'InvoiceReconciliationDesc',
})
export default class InvoiceReconciliationDesc extends Vue {

  public showDialog = false;
  public loading = false;
  //付款单号码、分配时间、分配金额，精确到分
  public tableCol = [
    {
      label: "付款单号码",
      prop: "receiptCode",
      key: "receiptCode"
    },
    {
      label: "分配金额",
      prop: "allocateAmount",
      key: "allocateAmount"
    },
    {
      label: "分配时间",
      prop: "createdTime",
      key: "createdTime",
      render: (prop, row) => {
        return parseTime(row.createdTime,"{y}-{m}-{d} {h}:{i}")
      }
    },
  ]
  private table = {
    list: [] as any[],
  };

  private async getList(id) {
    getReconciliationAllocateDetail({id})
        .then(({data}) => {
          (this.table.list as any) = data;
          this.loading = false;
        })
  }

  public async openDialog(obj) {
    this.showDialog = true;
    this.getList(obj.id)
  }
}
